import { render } from "./FeederPrintA3.vue?vue&type=template&id=cfb7d46e&scoped=true"
import script from "./FeederPrintA3.vue?vue&type=script&lang=js"
export * from "./FeederPrintA3.vue?vue&type=script&lang=js"

import "./FeederPrintA3.vue?vue&type=style&index=0&id=cfb7d46e&lang=css"
import "./FeederPrintA3.vue?vue&type=style&index=1&id=cfb7d46e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-cfb7d46e"

export default script